import React from "react"

import styles from "./NumericList.module.scss"

const NumericList = ({ heading, list, background }) => {
  const listFiltered = Array.isArray(list)
    ? list.map((item, i) => {
        return <li key={i}>{item}</li>
      })
    : []

  return (
    <section
      className={`${styles.element} ${
        background ? styles[background] : styles.pink
      } make-full-width-on-mobile`}
    >
      <div className={styles.container}>
        <h2>{heading}</h2>
        {listFiltered.length > 0 && (
          <ol className={styles.list}>{listFiltered}</ol>
        )}
      </div>
    </section>
  )
}

export default NumericList
